<template>
  <div>

    <hb-form
      label="System ID"
      required
    >
      <HbTextField
        v-if="!connection.Credentials.connected"
        id="system_id"
        name="system_id"
        placeholder="Enter System ID"
        v-validate="'required|max:45'"
        v-model="connection.Credentials.system_id"
        data-vv-as="System ID"
        data-vv-scope="gate"
        data-vv-name="system_id"
        :error="errors.collect('gate.system_id').length > 0"
      />
      <span v-if="connection.Credentials.connected">{{connection.Credentials.system_id}}</span>
    </hb-form>
    <hb-form
      label="Cloud Node ID"
      required
    >
      <HbTextField
        v-if="!connection.Credentials.connected"
        id="cloud_node"
        name="cloud_node"
        placeholder="Enter Cloud Node ID"
        v-validate="'required|max:45'"
        v-model="connection.Credentials.cloud_node"
        data-vv-as="Cloud Node ID"
        data-vv-scope="gate"
        data-vv-name="cloud_node"
        :error="errors.collect('gate.cloud_node').length > 0"
      />
      <span v-if="connection.Credentials.connected">{{connection.Credentials.cloud_node}}</span>
    </hb-form>

    <hb-form
      v-if="connection.Credentials.connected"
      label="PDK Group"
      required
    >
      <HbSelect
          :disabled="connection.Credentials.group_id != null || loadingConfigurations"
          :items="pdkGroupArray"
          item-text="name"
          item-value="id_group"
          :id="'pdk_group'"
          :name="'pdk_group'"
          placeholder="Select Group"
          v-validate="'required'"
          v-model.lazy="selectedGroup"
          data-vv-name="pdk_group"
          data-vv-scope="gate"
          data-vv-as="Group"
          :error="errors.collect('gate.pdk_group').length > 0"
        />
      </hb-form>

    <hb-form label="Pin Range" required full :auto-layout="false">
      <v-row no-gutters>
          <div class="hb-inline-sentence-text">
              Minimum: <span v-if="connection.Credentials.connected">{{connection.Credentials.pin_min}}</span>
          </div>
          <HbSelect
              v-if="!connection.Credentials.connected"
              box
              condensed
              medium
              placeholder="Select"
              v-model="connection.Credentials.pin_min"
              :items="mins"
              v-validate="'required'"
              data-vv-scope="gate"
              data-vv-name="pin_min"
              data-vv-as="Minimum Pin"
              :error="errors.has('gate.pin_min')"
          />
          
          <div class="hb-inline-sentence-text">
              Maximum: <span v-if="connection.Credentials.connected">{{connection.Credentials.pin_max}}</span>
          </div>
          <HbSelect
              v-if="!connection.Credentials.connected"
              box
              condensed
              medium
              placeholder="Select"
              v-model="connection.Credentials.pin_max"
              :items="maxs"
              v-validate="'required'"
              data-vv-scope="gate"
              data-vv-name="pin_max"
              data-vv-as="Maximum Pin"
              :error="errors.has('gate.pin_max')"
          />
      </v-row>
    </hb-form>

    <hb-form
      v-if="showPinLenght"
      label="Pin Length"
      required
    >
      <HbSelect
        v-if="!connection.Credentials.connected"
        :items="pin_formats"
        id="pin_format"
        name="pin_format"
        placeholder="Select Pin Length"
        v-validate="'required'"
        v-model="connection.Credentials.pin_format"
        data-vv-as="Pin Length"
        data-vv-scope="gate"
        data-vv-name="pin_format"
        :clearable="false"
        :error="errors.collect('gate.pin_format').length > 0"
      />
      <span v-if="connection.Credentials.connected">{{connection.Credentials.pin_format}}</span>
    </hb-form>

  </div>
</template>
<script type="text/babel">
import api from "../../../assets/api.js";
import { EventBus } from "../../../EventBus.js";
import { notificationMixin } from  '../../../mixins/notificationMixin.js';
export default {
  name: "PDK2.0",
  mixins: [notificationMixin],
  data() {
    return {
      connection: {
        property_id: "",
        access_id: "",
        Credentials: {
          system_id: "",
          cloud_node: "",
          modified_by_fullname: "",
          modified_at: "",
          connected: false
        }
      },
      pin_formats: [],
      mins: ["3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      maxs: [],
      showPinLenght: false,
      savingInProgress: false,
      pdkGroupArray: [],
      selectedGroup: null,
      collapseAudit: false
    };
  },
  created() {
    this.$emit('connectButtonText', "Connect to PDK 2.0");
  },
  mounted() {
    if(this.$props.access.Credentials) {
      this.connection = this.$props.access;
      if (this.connection.Credentials.connected) {
        this.selectedGroup = this.connection.Credentials.group_id;
        this.getPdkGroups();
      }
    }
  },
  destroyed(){
    this.$validator.errors.clear()
  },
  computed: {
     editTime(){
        if(this.connection.modified_at) return this.$options.filters.formatDateTime(this.connection.modified_at);
        return '';
     },
     displayUpdate() {
        return this.connection?.Credentials?.connected && this.connection.Credentials.group_id == null
      }
  },
  methods: {
    fetchData() {
      EventBus.$emit('fetchSettingsAccess');
    },
    getPdkGroups() {
      if (this.property_id) {
        this.loadingConfigurations = true;
        api
        .get(
          this,
          `${api.ACCESS_CONTROL}properties/${this.property_id}/facilities/${this.accessFacilityId}/vendor-configuration`
        )
        .then(r => {
          if (r?.configurations) {
            this.pdkGroupArray = r.configurations;
            this.loadingConfigurations = false;
          }
        });
      }
    },
    async save(update = false) {
      let gate_status = await this.$validator.validate();

      if (!gate_status) {
        this.showMessageNotification({ type: 'error', description: 'There are errors in your form, correct them before continuing.', list: this.errors.items });
        return;
      } 

      this.savingInProgress = true;
      if (update && (!this.selectedGroup || Object.keys(this.selectedGroup).length === 0)) {
        this.savingInProgress = false;
        this.showMessageNotification({
          type: 'error',
          description: 'Please select a valid PDK Group before updating.'
        });
        return;
      }
      let data;

      if (update) {
        data = {
          property_id: this.$props.property_id,
          facility_id: this.accessFacilityId,
          access_id: this.$props.selectedGateAccessId,
          Credentials: {
            group_id: this.selectedGroup
          }
        };
        
      } else {
        data = {
        property_id: this.$props.property_id,
        access_id: this.$props.selectedGateAccessId,
        satellite_flag: this.connection.satellite_flag,
        access_name: this.access.access_name,
        Credentials: {
          system_id: this.connection.Credentials.system_id,
          cloud_node: this.connection.Credentials.cloud_node,
          pin_format: this.connection.Credentials.pin_format,
          pin_min: this.connection.Credentials.pin_min,
          pin_max: this.connection.Credentials.pin_max,
        }
      };
      }


      try {

        let r = await api.post(this, api.ACCESS_CONTROL, data);
        this.fetchData();
        if (update) {
          this.showMessageNotification({ type: 'success', description: 'You have successfully connected to the PDK 2.0 access control integration.' });
        } else {
          this.showMessageNotification({ type: 'success', description: 'You have successfully added the PDK 2.0 access control integration.' });
        }
        
      } catch( err ) {
        this.showMessageNotification({ description: 'Please verify your credentials and try again or contact Customer Success for assistance.' });
      }

      this.savingInProgress = false;
    },
    populateArray(start, end) {
      const arr = [];
      start = parseInt(start);
      end = parseInt(end);
      for (let i = start; i <= end; i++) {
        arr.push(i.toString());
      }

      return arr;
    },
    setAuditCollapse() {
      let bottomBar = this.$refs.bottomRemoveBar;
      if (bottomBar && bottomBar.$el.offsetWidth > 0 && bottomBar.$el.offsetWidth < 570) {
        this.collapseAudit = true
      } else {
        this.collapseAudit = false
      }
    }
  },
  watch: {
    access() {
      this.connection = this.access;
      if (this.connection.Credentials) {
        this.selectedFacility = this.connection.Credentials.facility_id;
        this.getPdkGroups();
      }
    },
    'connection.Credentials.pin_min'() {
      this.maxs = this.populateArray(this.connection.Credentials.pin_min, 12)
    },
    'connection.Credentials.pin_max'() {
      this.showPinLenght = true;
      this.pin_formats = this.populateArray(this.connection.Credentials.pin_min, this.connection.Credentials.pin_max)
    },
    savingInProgress(value) {
      this.$emit('update:savingAccess', value);
    },
    async saveInVendor(value) {
      if (value === true) {
        await this.save();
        this.$emit('update:saveInVendor', false);
      }
    },
    async updateInVendor(value) {
      if (value === true) {
        await this.save(true);
        this.$emit('update:updateInVendor', false);
      }
    },
    displayUpdate(showUpdateButton) {
      this.$emit("update:showUpdateButton", showUpdateButton);
    }
  },
  props: ["property_id", "access", "selectedGateAccessId", "removeInProgress", "showUpdateButton", "savingAccess", "saveInVendor", "updateInVendor", "testVendorConnection", "accessFacilityId"]
};
</script> 